<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <CustomerMasterForm
        ref="customerForm"
        v-model="customerForm"
        label-width="10em"
        formMode="search"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-customer-name-set="autocompleteCustomerNameSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import CustomerMasterForm from '@/components/organisms/dialog/master/CustomerMasterForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    CustomerMasterForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerNameSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      customerForm: {
        customer_code: undefined,
        customer_name: undefined,
        private_id: undefined,
        invoice_address: undefined,
        postal_code: undefined,
        street_address: undefined,
        phone_number: undefined,
        owner_type: undefined,
        billing_day: undefined,
        transfer_day: undefined,
        invoice_type: undefined,
        // 20220510髙森追記
        billing_exclusion_flag: undefined,
        email_target: undefined
        // ここまで
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.customerForm.clearFields()
    },
    clickSearch () {
      this.$refs.customerForm.validate()
        .then((valid) => {
          sessionStorage.setItem('customerSearchCond', JSON.stringify(this.customerForm))
          this.dialogVisible = false
          this.$emit('search', this.customerForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('customerSearchCond'))
      this.$nextTick(() => {
        this.$refs.customerForm.clearFields()
        if (searchCond) {
          Object.keys(this.customerForm).forEach((x) => {
            this.$set(this.customerForm, x, searchCond[x])
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
